export function getBaseUrl() {
  const url = process.env.VUE_APP_BASE_API;
  return url;
}
export default getBaseUrl;
